import {
  useState
} from 'react';
import { useMediaQuery, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Footer from '../components/Footer.jsx';
import AgeVerification from '../components/AgeVerification.jsx';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../AppContext';
import { useNBCUSDK } from "../context/sdk/useSDK.js";
import { ROUTES } from '../routes/routeConstants';
import FAQ from '../components/FAQ';
import './StartPage.css';

const question = require('../assets/question_2x.png');
const epic_logo = require('../assets/UEU-Logo-Drop-Shadow_optimized 1.png');

const StartPage = () => {
  const navigate = useNavigate();

  const [isLoading] = useState(false);
  const [showAgeModal, setShowAgeModal] = useState(false);

  const { userProfile } = useAppContext();
  // Location not used in component
  // const location = useLocation();
  // const state = location.state || {}; // Uncomment if needed in the future
  const { handleOAuthLogin } = useNBCUSDK();

  // Effect was empty, removed to avoid lint warnings

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div>
      {!showAgeModal && <div className="background">
        <img 
          src={epic_logo} 
          alt="Universal Epic Universe logo" 
          style={{
            display: 'block',
            margin: '0 auto',
            width: '100%',
            maxWidth: 270
          }} 
        />
        <img 
          src={question} 
          alt="Mystery medallion" 
          width={isSmallScreen ? 140 : 200} 
          style={{
            display: 'block',
            margin: isSmallScreen ? '25px auto 15px auto' : '45px auto 15px auto',
            width: '80%',
            maxWidth: 270
          }} 
        />
        <h2 style={{
          color: '#fff',
          fontWeight: 600,
          textAlign: 'center',
          lineHeight: '48px',
          fontSize: '20px',
          maxWidth: 780,
          display: 'block',
          margin: '50px auto 0 auto',
          letterSpacing: 2
        }}>
          UNIVERSAL EPIC UNIVERSE
        </h2>
        <h2 style={{
          color: '#fff',
          fontWeight: 600,
          textAlign: 'center',
          lineHeight: '48px',
          fontSize: isSmallScreen ? '36px' : '38px',
          maxWidth: 780,
          display: 'block',
          margin: '0 auto',
          letterSpacing: 0,
          padding: '0 10px'
        }}>
          Grand Opening Day Digital Medallion
        </h2>
        <p style={{
          textAlign: 'center',
          fontSize: isSmallScreen ? '14px' : '20px',
          lineHeight: isSmallScreen ? '20px' : '28px',
          maxWidth: 600,
          margin: isSmallScreen ? '20px auto' : '40px auto',
          padding: '0 10px'
        }}>
          Be part of history as one of the first guests at Universal Epic Universe Grand Opening Day. Collect your medallion and stay tuned for more fun coming soon!
        </p>
        {/* Expiration notice with high contrast for accessibility */}
        <p 
          style={{
            display: 'block',
            textAlign: 'center',
            fontSize: '14px',
            color: '#cecece', // White text for contrast
            margin: '0 auto',
            maxWidth: '200px',
            borderRadius: '4px',
            fontWeight: 300,
            textShadow: '1px 1px 4px #000000'
          }}
        >
          Redeem by 5/22/2026
        </p>
        {userProfile.userId ? (
          <button className='redeem-btn button-glow' onClick={() => navigate(ROUTES.COLLECTION)}>
            View Collection
          </button>
        ) : (
          <button className='redeem-btn' onClick={() => setShowAgeModal(true)} disabled={isLoading}>
            {isLoading ? <CircularProgress size={25} style={{ color: '#000000' }} /> : "Sign In To Redeem"}
          </button>
        )}
        <FAQ/>
      </div>}
      {!showAgeModal && <Footer />}
      {showAgeModal && <AgeVerification onComplete={() => {
        setShowAgeModal(false);
        handleOAuthLogin();
      }}/>}
    </div>
  );
};

export default StartPage;